import type { ExternalSiteCheckRule } from "../../types";
import { decodedStartsWith } from "../../utils";
import { CAFE24_PAGE, SITE_TYPE } from "./const";

const isCafe24HomePath = (pathname: string) => {
  const result = ["/", "/index.html"].some((path) => {
    return path === pathname;
  });
  return result;
};

const cafe24: ExternalSiteCheckRule = {
  type: SITE_TYPE,

  checkPage({ url, target }) {
    const urlSearchParams = url.pathname + url.search; // 파라미터까지 비교하기 위해 사용

    if (target.value === "HOME" && isCafe24HomePath(url.pathname)) {
      return true;
    }

    if (
      target.value === CAFE24_PAGE.LOGIN.target &&
      url.pathname === CAFE24_PAGE.LOGIN.url
    ) {
      return true;
    }

    if (
      target.value === CAFE24_PAGE.SIGNUP.target &&
      url.pathname === CAFE24_PAGE.SIGNUP.url
    ) {
      return true;
    }

    if (
      target.value === CAFE24_PAGE.SIGNUP_COMPLETE.target &&
      url.pathname === CAFE24_PAGE.SIGNUP_COMPLETE.url
    ) {
      return true;
    }

    if (
      target.value === CAFE24_PAGE.ORDER_SUCCESS.target &&
      url.pathname === CAFE24_PAGE.ORDER_SUCCESS.url
    ) {
      return true;
    }

    if (
      target.value === CAFE24_PAGE.MY_PAGE.target &&
      url.pathname === CAFE24_PAGE.MY_PAGE.url
    ) {
      return true;
    }

    if (
      target.value === CAFE24_PAGE.CART.target &&
      url.pathname === CAFE24_PAGE.CART.url
    ) {
      return true;
    }

    if (
      target.value === CAFE24_PAGE.GUIDE.target &&
      url.pathname === CAFE24_PAGE.GUIDE.url
    ) {
      return true;
    }

    if (
      target.value === CAFE24_PAGE.FIND_ID.target &&
      url.pathname === CAFE24_PAGE.FIND_ID.url
    ) {
      return true;
    }

    if (
      target.value === CAFE24_PAGE.FIND_PASSWORD.target &&
      url.pathname === CAFE24_PAGE.FIND_PASSWORD.url
    ) {
      return true;
    }

    if (
      target.value === CAFE24_PAGE.MEMBER_MODIFY.target &&
      url.pathname === CAFE24_PAGE.MEMBER_MODIFY.url
    ) {
      return true;
    }

    if (
      target.value === CAFE24_PAGE.CHECK_ORDER.target &&
      url.pathname === CAFE24_PAGE.CHECK_ORDER.url
    ) {
      return true;
    }

    if (
      target.value === CAFE24_PAGE.WISH_LIST.target &&
      url.pathname === CAFE24_PAGE.WISH_LIST.url
    ) {
      return true;
    }

    if (
      target.value === CAFE24_PAGE.CHECK_MILEAGE.target &&
      url.pathname === CAFE24_PAGE.CHECK_MILEAGE.url
    ) {
      return true;
    }

    if (
      target.value === CAFE24_PAGE.COUPON.target &&
      url.pathname === CAFE24_PAGE.COUPON.url
    ) {
      return true;
    }

    if (
      target.value === CAFE24_PAGE.BOARD_LIST.target &&
      url.pathname === CAFE24_PAGE.BOARD_LIST.url
    ) {
      return true;
    }

    if (
      target.value === CAFE24_PAGE.DELIVERY_ADDR_LIST.target &&
      url.pathname === CAFE24_PAGE.DELIVERY_ADDR_LIST.url
    ) {
      return true;
    }

    if (
      target.value === CAFE24_PAGE.REGULAR_DELIVERY_LIST.target &&
      url.pathname === CAFE24_PAGE.REGULAR_DELIVERY_LIST.url
    ) {
      return true;
    }

    if (target.value === CAFE24_PAGE.CATEGORY.target) {
      //path로 구분
      const conditionPathname = target.params?.productSlug
        ? `${CAFE24_PAGE.CATEGORY.url}/${target.params.productSlug}`
        : `${CAFE24_PAGE.CATEGORY.url}`;
      if (decodedStartsWith(url.pathname, conditionPathname)) {
        return true;
      }
    }

    if (target.value === CAFE24_PAGE.PRODUCT.target) {
      //parameter로 구분
      //쇼핑몰마다 상품 목록과 상품 상세에 대한 주소가 제각각 달라서 상품 목록과 상품 상세에 대한 구분없이 PRODUCT로 이용하고 페이지별 상세하게 구분이 필요할시 slug를 이용하도록 처리
      const conditionPathname = target.params?.productSlug
        ? `${CAFE24_PAGE.PRODUCT.url}/${target.params.productSlug}`
        : `${CAFE24_PAGE.PRODUCT.url}`;
      if (decodedStartsWith(urlSearchParams, conditionPathname)) {
        return true;
      }
    }

    return false;
  },
};

export default cafe24;
